export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/ArrowDown.395f8a9d.svg","height":6,"width":10,"blurWidth":0,"blurHeight":0};